import api from './api';
import { IPrefilledDocument, IPrefilledDocumentSummary } from '../types/prefilledDocument';

export const prefilledDocumentService = {
  create: async (sourceDocumentId: string, file: File): Promise<IPrefilledDocument> => {
    const formData = new FormData();
    formData.append('sourceDocumentId', sourceDocumentId);
    formData.append('file', file);
    const response = await api.post<IPrefilledDocument>('/prefilled-documents', formData);
    return response.data;
  },

  list: async (): Promise<IPrefilledDocumentSummary[]> => {
    const response = await api.get<IPrefilledDocumentSummary[]>('/prefilled-documents');
    return response.data;
  },

  getById: async (id: string): Promise<IPrefilledDocument> => {
    const response = await api.get<IPrefilledDocument>(`/prefilled-documents/${id}`);
    return response.data;
  },

  update: async (id: string, data: { title?: string; filledText?: string }): Promise<IPrefilledDocument> => {
    const response = await api.patch<IPrefilledDocument>(`/prefilled-documents/${id}`, data);
    return response.data;
  },

  remove: async (id: string): Promise<void> => {
    await api.delete(`/prefilled-documents/${id}`);
  },
};
